
export default function ServiceDetailHead() {
  return (
    <>
    <section className="detailserv-head header-gap">
        <div className="container">
            <div className="row">

                <div className="col-lg-12">
                    <span className="sub-tittle">Service</span>
                    <h1 className="heading">Modular Work</h1>
                    <p>Modern modular systems engineered for real life - beautiful, efficient, and built to last. Seamlessly blending form and function, our modular solutions bring timeless sophistication to kitchens, wardrobes, and living spaces.</p>
                </div>
    
            </div>
        </div>

        <img src="/image/modular-banner.webp" loading="lazy" className="img-responsive" alt="service"/>
    </section>  
    </>
  )
}
